export default [
    {
        path: '/ghgjokiuoirtwiouewiurgeryweiw',
        name: 'calendar',
        meta: {
            title: 'Activities',
            authRequired: true,
            acc: null,
        },
        component: ()=> import('@/views/calendar/index.vue')
    },
    {
        path: '/ghgjokiuoirtwiouewiurgeryweiw',
        name: 'viewCalendar',
        meta: {
            title: 'Calendar',
            authRequired: true,
            acc: null,
        },
        component: ()=> import('@/views/calendar/index.vue')
    },

]